import { paymentSuccess } from '@/api/urls';

export const addKrPerMonth = (value: any) => {
 const decimalSplitArr = value.toFixed(2).split(".");
 const priceWithSuffix = decimalSplitArr[1] === "00" ? `${decimalSplitArr[0]},-/md.` : `${decimalSplitArr[0]},${decimalSplitArr[1]},-/md.`;
 return priceWithSuffix;
}

export const addKr = (value: any) => {
  const decimalSplitArr = value.toFixed(2).split(".");
  const priceWithSuffix = decimalSplitArr[1] === "00" ? `${decimalSplitArr[0]},-` : `${decimalSplitArr[0]},${decimalSplitArr[1]},-`;
  return priceWithSuffix;
}

export const isEmpty = (inputObject: any) => {
  return inputObject && Object.keys(inputObject)?.length === 0;
};

export const detectSuccessfulPaymentURL = (location: Location) =>
  location.pathname.replace(/\/$/, '') === paymentSuccess.url();
